import { skillsIniziali } from "./fixtures/skills";

export type Skill = {
  id: string;
  nome: string;
  descrizione: string;
};

const wait = (milliseconds: number) => new Promise((resolve) => setTimeout(resolve, milliseconds));
let skillsInMemory: Skill[] = skillsIniziali.map((skill) => ({ ...skill }));

export async function listSkills(): Promise<Skill[]> {
  await wait(180);
  return skillsInMemory.map((skill) => ({ ...skill }));
}

export async function createSkill(input: Pick<Skill, "nome" | "descrizione">): Promise<Skill> {
  await wait(220);
  const skill = { id: `skill-${Date.now()}`, nome: input.nome.trim(), descrizione: input.descrizione.trim() };
  skillsInMemory = [...skillsInMemory, skill];
  return { ...skill };
}
